import * as React from "react";
import {
  ActivityFragment,
  MadMinimalFragment,
  ReportFragment,
} from "../../../graphql/fragments";
import useTranslations from "../../../hooks/useTranslations";
import { timeAgoLabel } from "../../../utils/timeAgo";
import { MadIcon } from "../../icons";
import { Link } from "../../wombat-ui";
import { Span } from "../../wombat-ui/components/Typography";
import Activity from "../ActivityPlate";

type ReportCheckedActivity = ActivityFragment & {
  recipient: MadMinimalFragment;
  trackable: ReportFragment;
};

export function isReportCheckedActivity(
  q: ActivityFragment
): q is ReportCheckedActivity {
  return q.key === "report.checked";
}

interface ReportCheckedActivityProps {
  activity: ReportCheckedActivity;
}

export const ReportCheckedActivity: React.FC<ReportCheckedActivityProps> = ({
  activity,
}) => {
  const t = useTranslations();

  return (
    <Activity
      activity={activity}
      id="reportCheckedActivity"
      visual={<MadIcon iconClassName="w-10 h-10 text-accent-500" />}
    >
      <Span className="text-sm">
        {t("activity.labels.reportChecked", {
          report: (
            <Link
              to={`/reports/${activity.trackable.id}`}
              key={activity.id}
            >
              {t("activity.objects.report")}
            </Link>
          ),
        })}
      </Span>
    </Activity>
  );
};
